module.exports = "https://cdn.realtymogul.com/static/media/img_retirement.7b368d2b.jpg";